/**
 * @generated SignedSource<<734ec489b33b2cfc180feb2220d8dea4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontHome_storefrontData$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly serviceId: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontCreatorsUrls_featuredCreatorsUrls" | "StorefrontFeaturedSection_products">;
  readonly " $fragmentType": "StorefrontHome_storefrontData";
};
export type StorefrontHome_storefrontData$key = {
  readonly " $data"?: StorefrontHome_storefrontData$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontHome_storefrontData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontHome_storefrontData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DealerStorefrontQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_products"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontCreatorsUrls_featuredCreatorsUrls"
    }
  ],
  "type": "DealerStorefrontQueryConnection",
  "abstractKey": null
};

(node as any).hash = "a56ef9d086aa326c8205cd08bd497ba1";

export default node;
